import React, {useCallback, useEffect, useState} from "react";
import styled from "@emotion/styled";
import {useDispatch, useSelector} from "react-redux";
import {clearContestPointsRequest} from "modules/actions";
import {getIsContestCleared} from "modules/selectors";
import {BASE_URL} from "modules/constants";
import RallySSO from "modules/utils/SSO/rallySSO";

const Wrapper = styled.div``;

interface IProps {
	children: React.ReactElement;
}
export const HOCSecretKey: React.FC<IProps> = ({children}) => {
	const dispatch = useDispatch();
	const [click, setClick] = useState<number>(0);
	const isCleared = useSelector(getIsContestCleared);

	useEffect(() => {
		if (!isCleared) {
			return;
		}

		if (RallySSO.IS_NATIVE) {
			RallySSO.nativeBridge?.close();
		} else {
			window.location.href = BASE_URL;
		}
	}, [isCleared]);

	const increaseClick = useCallback(() => {
		const newClick = click + 1;
		if (newClick >= 10) {
			dispatch(clearContestPointsRequest());
			return;
		}

		setClick(newClick);
	}, [click, dispatch]);

	return <Wrapper onClick={increaseClick}>{children}</Wrapper>;
};
